import React, { Component } from 'react';
import * as $ from 'jquery';
import { GENDER } from './ProfileContainer.js';
import { translate } from 'react-i18next';

class UserProfile extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentDidMount() {
    $('#birthdate').datepicker({
      onSelect: (d, i) => {
        if (d !== i.lastVal) {
          this.props.handleBirthdateChange(d);
        }
      }
    });
    $('#btnEdit').click();
  }

  getInitState = () => {
    return { isEditing: false };
  }

  handleCancelClick = () => {
    this.setState({ isEditing: false });
    this.props.handleCancelClick();
  }

  handleEditClick = () => {
    this.setState({ isEditing: true });
  }

  handleProfileSubmit = (event) => {
    this.setState({ isEditing: false });
    this.props.handleProfileSubmit(event);
  }

  handlePasswordClick = (event) => {

  }

  render() {
    const isEditing = this.state.isEditing;
    const user = this.props.user;
    const { t } = this.props;

    return (
      <div className="content-resvations">
        <div className="container-resvations">
          <div className="row">
            <div className="col-md-6 col-md-push-6 col-lg-4 col-lg-push-8 text-center">
              <a onClick={() => $('#chooserProfile').click()}>
                <div className="badge-wrapper">
                  <img alt={t('dashboard.profile.img_user')} src={user.picture} />
                </div>
              </a>
              <br />
              <h4 className="text-secondary">
                <strong>{user.name + " " + user.lastname}</strong>
                <br />
                <small className="text-secondary">#{user.user_id}</small>
              </h4>
              <br />
              <span className={isEditing ? "hidden" : ""}>
                <div className="form-group">
                  <button
                    className="btn btn-primary btn-singup"
                    onClick={this.handleEditClick}
                    type="button"
                    id="btnEdit">
                    {t('dashboard.profile.btn_edit')}
                  </button>
                </div>
              </span>
              <span>
                <div className="form-group">
                  <button
                    className="btn btn-primary btn-singup"
                    onClick={this.props.handlePasswordClick}
                    type="button"
                    id="btnEdit">
                    {t('dashboard.profile.btn_password')}
                  </button>
                </div>
              </span>

              {/* {<div className={user.balance ? "form-group" : "hidden"}>
                <button
                  className="btn btn-primary btn-singup"
                  onClick={this.props.showBalance}
                  type="button">{t('dashboard.profile.btn_balance')}
                  </button>
              </div>} */}
              <br />
            </div>
            <div className="col-md-6 col-md-pull-6 col-lg-8 col-lg-pull-4">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h4 className="panel-title">{t('dashboard.profile.heading_user')}</h4>
                  {!this.props.user.name || !this.props.user.lastname || !this.props.user.phone || this.props.user.birthdate === "Invalid date" ? (
                    <h4 style={{ color: "red" }}>Favor de Completar los Datos Faltantes</h4>
                  ) : null}
                  {this.props.user.ios_express === "1" ? (
                    <h4 style={{ color: "red" }}>Favor de Cambiar la Contraseña</h4>
                  ) : null}

                </div>
                <div className="panel-body">
                  <form method="post" onSubmit={this.handleProfileSubmit}>
                    <fieldset>
                      <input
                        className="hidden"
                        id="chooserProfile"
                        onChange={this.props.handleProfilePicture}
                        type="file" />
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="name">
                              {t('dashboard.profile.label_name')}
                              {!this.props.user.name ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="name"
                              onChange={this.props.handleNameChange}
                              placeholder={t('dashboard.profile.holder_name')}
                              type="text"
                              value={user.name} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="lastname">
                              {t('dashboard.profile.label_lastname')}
                              {!this.props.user.lastname ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing} id="lastname"
                              onChange={this.props.handleLastnameChange}
                              placeholder={t('dashboard.profile.holder_lastname')}
                              type="text"
                              value={user.lastname} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="email">
                              {t('dashboard.profile.label_email')}
                            </label>
                            <input
                              className="form-control"
                              id="email"
                              readOnly
                              type="email"
                              value={user.email} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="contactEmail">
                              {t('dashboard.profile.label_cemail')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing} id="contactEmail"
                              onChange={this.props.handleContactEmail}
                              placeholder={t('dashboard.profile.holder_cemail')}
                              type="email"
                              value={user.contact_email} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="phone">
                              {t('dashboard.profile.label_phone')}
                              {!this.props.user.phone ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="phone"
                              onChange={this.props.handlePhoneChange}
                              placeholder={t('dashboard.profile.holder_phone')}
                              type="tel"
                              value={user.phone} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="position">
                              {t('dashboard.profile.label_position')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="position"
                              onChange={this.props.handlePositionChange}
                              placeholder={t('dashboard.profile.holder_position')}
                              type="text"
                              value={user.position} />
                          </div>
                        </div>



                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="phone">
                              {t('dashboard.profile.LinkedIn')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="phone"
                              onChange={this.props.handleProfileLinkedinChange}
                              placeholder={t('dashboard.profile.LinkedIn')}
                              type="tel"
                              value={user.perfilLinkedin} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="position">
                              {t('dashboard.profile.Instragram')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="position"
                              onChange={this.props.handleProfileInstagramChange}
                              placeholder={t('dashboard.profile.Instragram')}
                              type="text"
                              value={user.perfil_Instragram} />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="phone">
                              {t('dashboard.profile.Facebook')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="phone"
                              onChange={this.props.handleProfileFacebookChange}
                              placeholder={t('dashboard.profile.Facebook')}
                              type="tel"
                              value={user.perfil_facebook} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="business">
                              {t('dashboard.profile.label_business')}
                            </label>
                            <select
                              className="form-control"
                              disabled={!isEditing}
                              id="business"
                              onChange={this.props.handleBusinessChange}
                              value={user.business_id}>
                              <option value="">{t('dashboard.profile.holder_select')}</option>
                              {this.props.business.map((object, index) =>
                                <option key={index} value={object.id}>{object.name}</option>
                              )}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="description">
                              {t('dashboard.profile.label_description')}
                            </label>
                            <textarea
                              maxLength="250"
                              className="form-control"
                              disabled={!isEditing}
                              id="description"
                              onChange={this.props.handleDescriptionChange}
                              placeholder={t('dashboard.profile.holder_description')}
                              rows="3"
                              value={user.description} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="birthdate">
                              {t('dashboard.profile.label_birthdate')}
                              {this.props.user.birthdate === "Invalid date" ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <input
                              autoComplete="off"
                              className="form-control"
                              disabled={!isEditing}
                              id="birthdate"
                              onChange={(e) => this.props.handleBirthdateChange(e.target.value)}
                              placeholder={t('dashboard.profile.holder_birthdate')}
                              type="text"
                              value={user.birthdate} />
                          </div>
                        </div>
                        {/* {user.credits >= 0 &&
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="credits">
                                {t('dashboard.profile.label_credits')}
                              </label>
                              <input
                                className="form-control"
                                disabled
                                id="credits"
                                type="text"
                                value={"$" + Number(user.credits).toFixed(2) + " USD"} />
                            </div>
                          </div>
                        } */}
                      </div>
                      <div className="form-group">
                        <button
                          className="btn btn-link"
                          data-target="#moreFields"
                          data-toggle="collapse"
                          type="button">
                          {t('dashboard.profile.btn_more')}&nbsp;
                          <span className="caret" />
                        </button>
                      </div>
                      <div className="collapse" id="moreFields">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="gender">
                                {t('dashboard.profile.label_gender')}
                              </label>
                              <select
                                className="form-control"
                                disabled={!isEditing}
                                id="gender"
                                onChange={this.props.handleGenderChange}
                                value={user.gender}>
                                <option value={GENDER.MALE}>{t('dashboard.profile.gender_male')}</option>
                                <option value={GENDER.FEMALE}>{t('dashboard.profile.gender_female')}</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label htmlFor="interests">
                                {t('dashboard.profile.label_interests')}
                              </label>
                              <textarea
                                className="form-control"
                                disabled={!isEditing}
                                id="interests"
                                onChange={this.props.handleInterestsChange}
                                placeholder={t('dashboard.profile.holder_interests')}
                                rows="3"
                                value={user.interests} />
                            </div>
                          </div>

                        </div>
                      </div>
                      {this.props.user.ios_express === "1" ? (
                        <button
                          className="btn btn-primary btn-singup"
                          type="submit">
                          {t('dashboard.profile.btn_save')}
                        </button>
                      ) : (
                        <span className={isEditing ? "" : "hidden"}>
                          <button
                            className="btn btn-primary btn-singup"
                            type="submit">
                            {t('dashboard.profile.btn_save')}
                          </button>&nbsp;
                          <button
                            className="btn btn-outline btn-primary"
                            onClick={this.handleCancelClick}
                            type="button">
                            {t('dashboard.profile.btn_cancel')}
                          </button>
                        </span>
                      )}

                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

export default translate('common')(UserProfile);



// WEBPACK FOOTER //
// ./src/dashboard/profile/UserProfile.js